import React, { useState } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { ArrowRightIcon } from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { nextStep, setRole } from '../store';

const RoleSelectStep = () => {
  const t = useTranslations();
  const type = useAppSelector(state => state.authModal.data.role);
  const [selected, setSelected] = useState<string | null>(type);
  const dispatch = useAppDispatch();

  const options = [
    { label: t('abiturent'), image: '/images/abiturent.webp', value: 'APPLICANT' },
    { label: t('talaba'), image: '/images/student.webp', value: 'STUDENT' },
    { label: t('oqituvchi'), image: '/images/teacher.webp', value: 'TEACHER' },
    { label: t('boshqa'), image: '/images/other.webp', value: 'OTHER' }
  ];

  const onContinue = () => {
    dispatch(setRole(selected));
    dispatch(nextStep());
  };

  return (
    <div className="flex h-[94vh] sm:h-full w-full flex-col justify-between p-6">
      <div>
        <h3 className="mb-2 text-3xl font-semibold">{t('siz_kimsiz')}</h3>
        <p className="text-sm">{t('siz_dasturdan_kim_sifatida_foydalanasiz')}</p>
        <div className="mt-15 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {options.map(option => (
            <div
              key={option.label}
              onClick={() => setSelected(option.value)}
              className={classNames(
                'flex cursor-pointer flex-col items-center justify-center space-y-4 rounded-xl border py-5 transition',
                selected === option.value ? 'border-green-600 bg-green-50' : 'border-transparent bg-gray-50'
              )}
            >
              <div className="relative h-11 w-11">
                <Image src={option.image} title="Role tasvirlovchi rasm" fill alt={option.label} />
              </div>
              <p className="font-medium">{option.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-auto flex items-center justify-between">
        <div className="text-gray-400">3/8</div>
        <div className="flex items-center gap-3">
          <Button
            onClick={onContinue}
            disabled={!selected}
            className="!rounded-lg !border-transparent !bg-green-500 !px-5 !py-5 !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
          >
            {t('davom_etish')}
            <div className="mt-0.5 ">
              <ArrowRightIcon />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectStep;
